<template>
    <div>
        <proposal-header :proposal_document="data.proposal_document" />

        <proposal-valid-until
            :please-sign-by="data.proposal_document.please_sign_by"
            :mobile="true"
        />

        <div class="max-w-screen-xl mx-auto mb-32 px-8">
            <proposal-our-goals 
                :proposal_document="data.proposal_document"
                :section="data.proposal_document.sections.our_goals"
            />

            <proposal-job-board :section="data.proposal_document.sections.job_board" />
            <proposal-hiring-area
                :proposal_document="data.proposal_document"
                :section="data.proposal_document.sections.hiring_area"
            />
            <proposal-hammer-and-job-adviser :section="data.proposal_document.sections.hammer_and_job_adviser" />
            <proposal-mc-leads :section="data.proposal_document.sections.mc_leads" />
            <proposal-video-advertising :section="data.proposal_document.sections.video_advertising" />
            <proposal-brand-and-reputation :section="data.proposal_document.sections.brand_and_reputation" />
            <proposal-new-hire-guarantee :section="data.proposal_document.sections.new_hire_guarantee" />

            <template v-if="showPricing">
                <proposal-pricing-options 
                    v-model="selectedOption"
                    :data="data"
                />
            </template>

            <proposal-agreement
                v-if="data.proposal_document.sections.agreement.is_active"
                :data="data"
                :selected-option="selectedOption"
            />
        </div>
    </div>
</template>

<script>
import ProposalHeader from "./parts/proposal-10-header";

import ProposalOurGoals from "./parts/proposal-20-our-goals";
import ProposalJobBoard from "./parts/proposal-21-job-board";
import ProposalHiringArea from "./parts/proposal-22-hiring-area";
import ProposalHammerAndJobAdviser from "./parts/proposal-23-hammer-and-job-adviser";
import ProposalMcLeads from "./parts/proposal-24-mc-leads";
import ProposalVideoAdvertising from "./parts/proposal-25-video-advertising";
import ProposalBrandAndReputation from "./parts/proposal-26-brand-and-reputation";
import ProposalNewHireGuarantee from "./parts/proposal-27-new-hire-guarantee";

import ProposalPricingOptions from "./parts/proposal-30-pricing-options";
import ProposalAgreement from "./parts/proposal-40-agreement";
import ProposalValidUntil from "./parts/proposal-valid-until";

export default {
    components: {
        ProposalHeader,
        ProposalOurGoals,
        ProposalJobBoard,
        ProposalHiringArea,
        ProposalHammerAndJobAdviser,
        ProposalMcLeads,
        ProposalVideoAdvertising,
        ProposalBrandAndReputation,
        ProposalNewHireGuarantee,
        ProposalPricingOptions,
        ProposalAgreement,
        ProposalValidUntil
    },
    props: {
        identifier: { 
            type: String
        },
        data: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            selectedOption: 1
        }
    },
    computed: {
        showPricing() {
            if(! this.data.proposal_document.sections.pricing_options.is_active) {
                return false;
            }

            return this.data.pricing_option1.is_active
                || this.data.pricing_option2.is_active
                || this.data.pricing_option3.is_active
                || this.data.pricing_option4.is_active;
        },
        activeOptionNumbers() {
            return [1, 2, 3, 4].filter((number) => this.data['pricing_option' + number].is_active);
        },
    },
    created() {
        // Preselect the "recommended" plan (Pro / option 2) when active; otherwise the first active plan.
        if (this.data.pricing_option2.is_active) {
            this.selectedOption = 2;
        } else if (this.activeOptionNumbers.length) {
            this.selectedOption = this.activeOptionNumbers[0];
        }
    },
}
</script>